var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-form-x',{attrs:{"title":"SX_LANG_USER_INFO_EDIT","form":_vm.form},on:{"submit":_vm.updateUserInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }